import React from 'react';
import { Table, Tag, Typography } from 'antd';
import { mediaLibrary } from '../../mockData';
import './Media.css';

function MediaLibrary() {
  const { Title } = Typography;

  const columns = [
    { title: 'Type', dataIndex: 'type', key: 'type', render: (t) => <Tag>{t.toUpperCase()}</Tag> },
    { title: 'Name', dataIndex: 'name', key: 'name' },
    { title: 'Tags', dataIndex: 'tags', key: 'tags', render: (tags) => (tags || []).map((x) => <Tag key={x}>{x}</Tag>) },
    { title: 'Size (KB)', dataIndex: 'sizeKB', key: 'sizeKB', align: 'right' },
  ];

  return (
    <div className="agency-creatives-media">
      <Title level={3}>Shared Media Library</Title>
      <Table rowKey="id" columns={columns} dataSource={mediaLibrary} pagination={{ pageSize: 5 }} />
    </div>
  );
}

export default MediaLibrary;
